var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',{staticClass:"login",attrs:{"justify":"center"}},[_c('h2',[_vm._v(_vm._s(_vm.$t('login.welcomeMsg'))+",")]),_c('h4',[_vm._v(_vm._s(_vm.$t('login.signinTitle'))+"!")]),_c('AppLoginForm')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }